export default {
      id: "reefer-info-5-usage",
      viewBox: "0 0 21 34",
      url: __webpack_public_path__ + "img/icons.svg#reefer-info-5",
      toString: function () {
        return this.url;
      }
    }